import s from './Button.module.sass'

import { ErrorBoundary } from '../../../lib/components/ErrorBoundary'

import React, { forwardRef } from 'react'
import Link from 'next/link'

import { useCurrentSize } from '@shared/lib/helpers/classes'
import type { ButtonBaseProps } from './Button'

export interface LinkButtonProps extends React.AnchorHTMLAttributes<HTMLAnchorElement>, ButtonBaseProps {
  disabled?: boolean
}

const LinkButton = forwardRef<HTMLAnchorElement, LinkButtonProps>(
  ({ sizes, mode, className = '', children, href, disabled, ...rest }, ref) => {
    const [size] = useCurrentSize(sizes)

    if (disabled) {
      const handler = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        e.stopPropagation()
        e.preventDefault()
      }

      rest.onAuxClickCapture = handler
      rest.onClickCapture = handler
      rest.onContextMenuCapture = handler
      rest.onDoubleClickCapture = handler
      rest.onDragCapture = handler
      rest.onDragEndCapture = handler
      rest.onDragEnterCapture = handler
      rest.onDragExitCapture = handler
      rest.onDragLeaveCapture = handler
      rest.onDragOverCapture = handler
      rest.onDragStartCapture = handler
      rest.onDropCapture = handler
      rest.onMouseDownCapture = handler
      rest.onMouseMoveCapture = handler
      rest.onMouseOutCapture = handler
      rest.onMouseOverCapture = handler
      rest.onMouseUpCapture = handler
    }

    rest.role = 'button'

    return (
      <ErrorBoundary>
        <Link href={href} data-size={size} data-mode={mode} className={`${s.button} ${className}`} ref={ref} {...rest}>
          <div className={s.button__content}>{children}</div>
        </Link>
      </ErrorBoundary>
    )
  },
)

LinkButton.displayName = 'LinkButton'

export default LinkButton
